import * as cookie from './smartpak/cookie.js';
import * as dynamicYield from './vendor/dynamicyield/dynamicyield.js';
import cdProfileCookie from './smartpak/smartpak.cdprofilecookie.js';
import customer from './smartpak/customer.js';
import dataLayer from './vendor/googletagmanager/datalayer';
import namespace from './smartpak/smartpak.js';
import page from './smartpak/page.js';
import preferredLocationCookie from './smartpak/smartpak.preferredlocationcookie.js';
import smartPrimeCookie from './smartpak/smartpak.smartprimecookie.js';

if (!/confirmation/gi.test(location.pathname)) {
    dataLayer();
}

window.smartPak.namespace = namespace;
window.smartPak.dynamicYield = dynamicYield;
window.smartPak.cookie = cookie;
window.smartPak.page = page;
window.smartPak.customer = customer;
window.smartPak.cdProfileCookie = cdProfileCookie;
window.smartPak.smartPrimeCookie = smartPrimeCookie;
window.smartPak.preferredLocationCookie = preferredLocationCookie;
